import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getJobTitleById(careerId) {
		const url = careerId
			? `/api/Cms/jobTitle?careerId=${careerId}`
			: '/api/Cms/jobTitle';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(jobTitleData) {
		try {
			await axios.put(`${API_URL}/api/Cms/jobTitle`, jobTitleData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating simulation template:', error);
			throw error;
		}
	}
	async deleteById(jobTitleId) {
		try {
			await axios.delete(`${API_URL}/api/Cms/JobTitle?jobTitle=${jobTitleId}`, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
